import Component from '../Component';
import { setCookie, getCookie } from '../Helpers';
import $ from '../../vendor/CustomJquery';

export default class FontSizeScale extends Component {

  FONT_SIZE_KEY = 'font-size';

  configure() {
    this.cookieTTL = 720; // In days
    return super.configure();
  }

  initialize() {
    this.element = $('#fontSizeScale');
    this.subscribeToEvents();
    this.onStart();
    return super.initialize();
  }

  subscribeToEvents() {
    this.element.on('change', (event) => {
      this.onChange(event.currentTarget.value);
    });
  }

  onChange(fontSize) {
    this.logger(`Set font-size to ${fontSize}px`);
    $('html').css('font-size', fontSize + 'px');
    setCookie(this.FONT_SIZE_KEY, fontSize, this.cookieTTL);
  }

  onStart() {
    let value = getCookie(this.FONT_SIZE_KEY);
    if (value != null) {
      this.element.val(value);
    }
  }

}